import { BookmarkIcon } from "@heroicons/react/24/outline";

export default function InBookmarksTag() {
  return (
    <div className="inline-flex items-center justify-center space-x-2 rounded-md bg-amber-50 px-2 py-1 text-orange-600">
      <BookmarkIcon strokeWidth={0} className="inline-flex h-4 w-4 fill-orange-500 text-orange-600" />
      <strong className="text-xs font-bold uppercase tracking-tighter">Nos Favoritos</strong>
    </div>
  );
}
